<div class="SLV2-memorythumb-card" (click)="goToMemoryCards()">
    <span class="SLV2-memorythumb-lst-cunt"></span>
    <div class="SLV2-memorythumb-thumb">
        <ng-container>
            <img class="SLV2-memorythumb-thumb-pic" src="selflearnv2-ui/assets/img/self-learn-v2/brain-memory-icon.svg" />
        </ng-container>
        <!-- <img *ngIf="memoryData?.thumbnailURL" src='{{displayImage(memoryData.thumbnailURL)}}' />
        <span class="SLV2-memorythumb-time-tag">{{displayTime(memoryData.duration)}}</span> -->
        <span class="SLV2-memory-subjct-name">{{memoryData.chapterName}}</span>
    </div>
    <div class="SLV2-memorythumb-content-area">
        <div class="SLV2-memorythumb-info-row">
             <div class="SLV2-memorythumb-info">
                <img src="selflearnv2-ui/assets/img/eye-icon-2.svg" /><span>{{noOfViews}} views</span>
            </div> 
        </div>
        <h4 class="SLV2-memorythumb-title">
  <ng-container *ngIf="!isFromMyHistory">Q. <span [mathMl]="memoryData?.memorycarddata?.front?.text"></span></ng-container>
  <ng-container *ngIf="isFromMyHistory"><span>{{memoryData.chapterName}}</span></ng-container>
</h4>
    </div>

</div>